import { useQuery } from '@tanstack/react-query';
import { getCustomSurveysByTeamId } from '../../api/customSurveys';
import { customSurveyKeys } from './queryKeys';

export const useGetCustomSurveysByTeamIdQuery = (teamId: number) => {
  return useQuery({
    queryKey: customSurveyKeys.byTeam(teamId),
    queryFn: () => getCustomSurveysByTeamId(teamId),
    enabled: Boolean(teamId),
  });
};
